import i18nFactory from '@yandex-int/i18n';

import { GdViewType } from '../../typings/graphql-grid';

import * as keyset from './ViewTypeHelpers.i18n';

const i18n = i18nFactory(keyset);

const VIEW_TYPE_TEXTS = {
    [GdViewType.DESKTOP]: i18n('desktop-view'),
    [GdViewType.MOBILE]: i18n('mobile-view'),
    [GdViewType.NEW_TAB]: i18n('new-tab-view')
};

export class ViewTypeHelpers {
    public static getTypes(viewTypes?: GdViewType[]): string {
        if (!viewTypes) {
            return '';
        }

        return viewTypes.map(type => VIEW_TYPE_TEXTS[type]).join(', ');
    }
}
